<template>
  <c-button
    unelevated
    color="primary"
    v-bind="$attrs"
    padding="8px 10px"
    class="tw-aspect-square"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </c-button>
</template>

<style lang="scss">
.q-btn {
  text-transform: none !important;

  &--outline {
    &:before {
      border: 1px solid $grey;
    }
  }

  &--fab,
  &--fab-mini {
    .q-icon {
      font-size: initial;
    }
  }
}
</style>
